import { defineStore } from 'pinia';
import { ref } from 'vue'
import { useCcPaymentStore } from './payment_gateways/ccpayment';
import { usePaymentGatewaysStore } from '../payment_gateways';
import _ from 'lodash';
import { useBonusStore } from '../bonus';

export const useDepositsStore = defineStore('deposits', {
	state: () => ({
		payment_gateways: ref({}),
		available_bonuses: ref({}),
	}),
	getters: {
		getPaymentGateways(state) {
			const allowed_payment_gateways = ['plisio', 'coinpayments', 'hubtel', '0xprocessing', 'iran-voucher', 'central-pay', 'perfect-money', 'perfect-money-voucher', 'ccpayment', 'usdt', 'trx', 'utopia_voucher', 'slot4pay', 'manual_deposit_proof', 'gizapay', 'neopay', 'webpayz', 'paysay', 'aleapay', 'riverpe', 'modem_pay'];

			return _.filter(state.payment_gateways, (gateway) => {
				return _.includes(allowed_payment_gateways, gateway.slug);
			});
		},
		getAvailableBonuses(state) {
			return state.available_bonuses;
		},
		isCcpaymentEnabled(state) {
			return state.payment_gateways.some(gateway => gateway.slug === 'ccpayment');
		},
	},
	actions: {
		fetchPaymentGateways() {
			return global.axios.get(process.env.VUE_APP_API_URL + '/account/bank/deposit/payment_gateways').then((response) => {
				this.payment_gateways = response.data.data;

				return Promise.resolve(response.data.data);
			}).catch((error) => {
				return Promise.reject(error);
			})
		},
		fetchAvailableBonuses(payload) {
			return global.axios.get(process.env.VUE_APP_API_URL + '/account/bank/deposit/payment_gateway/' + payload + '/bonus').then((response) => {
				this.available_bonuses = response.data.data;

				return Promise.resolve(response.data.data);
			}).catch((error) => {
				return Promise.reject(error);
			})
		},
		getPaymentGateway(slug) {
			return _.find(this.payment_gateways, { 'slug': slug });
		},
		// Plisio
		createDepositPlisio(payload) {
			return global.axios.post(process.env.VUE_APP_API_URL + '/account/bank/deposit/plisio', payload).then((response) => {

				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error.response);
			})
		},
		// CoinPayments
		createDepositCoinPayments(payload) {
			return global.axios.post(process.env.VUE_APP_API_URL + '/account/bank/deposit/coinpayments', payload).then((response) => {

				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error.response);
			})
		},
		// 0xprocessing
		createDeposit0xProcessing(payload) {
			return global.axios.post(process.env.VUE_APP_API_URL + '/account/bank/deposit/0xprocessing', payload).then((response) => {

				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error.response);
			})
		},
		// Hubtel
		createDepositHubtelMobileMoney(payload) {
			return global.axios.post(process.env.VUE_APP_API_URL + '/account/bank/deposit/hubtel/mobile-money', payload).then((response) => {
				useBonusStore().fetchOffers();
				this.fetchAvailableBonuses('hubtel');
				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error.response);
			})
		},
		createDepositHubtelBankCard(payload) {
			return global.axios.post(process.env.VUE_APP_API_URL + '/account/bank/deposit/hubtel/bank-card', payload).then((response) => {
				useBonusStore().fetchOffers();
				this.fetchAvailableBonuses('hubtel');
				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error.response);
			})
		},
		// Iran Voucher
		createDepositIranVoucher(payload) {
			return global.axios.post(process.env.VUE_APP_API_URL + '/account/bank/deposit/iran-voucher', payload).then((response) => {
				useBonusStore().fetchOffers();
				this.fetchAvailableBonuses('iran-voucher');
				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error.response);
			})
		},
		// Central Pay
		createDepositCentralPay(payload) {
			return global.axios.post(process.env.VUE_APP_API_URL + '/account/bank/deposit/central-pay', payload).then((response) => {

				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error.response);
			})
		},
		// Perfect Money
		createDepositPerfectMoney(payload) {
			return global.axios.post(process.env.VUE_APP_API_URL + '/account/bank/deposit/V2/perfect-money', payload).then((response) => {

				let form = document.createElement('form');
				form.action = 'https://perfectmoney.com/api/step1.asp';
				form.method = 'post';
				form.style.display = 'none';
				document.body.appendChild(form);

				Object.entries(response.data.data).forEach(([name, value]) => {
					let input = document.createElement('input');
					input.setAttribute('name', name);
					input.setAttribute('value', value);
					form.appendChild(input);
				});

				form.submit();

				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error.response);
			})
		},
		// Perfect Money Voucher
		createDepositPerfectMoneyVoucher(payload) {
			return global.axios.post(process.env.VUE_APP_API_URL + '/account/bank/deposit/perfect-money-voucher', payload).then((response) => {

				// let form = document.createElement('form');
				// form.action = 'https://perfectmoney.com/api/step1.asp';
				// form.method = 'post';
				// form.style.display = 'none';
				// document.body.appendChild(form);

				// Object.entries(response.data.data).forEach(([name, value]) => {
				// 	let input = document.createElement('input');
				// 	input.setAttribute('name', name);
				// 	input.setAttribute('value', value);
				// 	form.appendChild(input);
				// });

				// form.submit();

				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error.response);
			})
		},
		// Utopia Voucher
		createDepositUtopiaVoucher(payload) {
			return global.axios.post(process.env.VUE_APP_API_URL + '/account/bank/deposit/utopia-voucher', payload).then((response) => {
				useBonusStore().fetchOffers();
				this.fetchAvailableBonuses('utopia_voucher');
				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error.response);
			})
		},
		// slot4pay
		createDepositSlot4Pay(payload) {
			return global.axios.post(process.env.VUE_APP_API_URL + '/account/bank/deposit/slot4pay', payload).then((response) => {
				useBonusStore().fetchOffers();
				this.fetchAvailableBonuses('slot4pay');
				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error.response);
			})
		},
		// Manual deposit proof (multipart)
		createDepositManualDepositProof(formData) {
			return global.axios.post(process.env.VUE_APP_API_URL + '/account/bank/deposit/manual-deposit-proof', formData).then((response) => {
				useBonusStore().fetchOffers();
				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error.response);
			})
		},
		// GizaPay
		createDepositGizaPay(payload) {
			return global.axios.post(process.env.VUE_APP_API_URL + '/account/bank/deposit/gizapay', payload).then((response) => {
				useBonusStore().fetchOffers();
				this.fetchAvailableBonuses('gizapay');
				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error.response);
			})
		},
		// Neopay
		createDepositNeopay(payload) {
			return global.axios.post(process.env.VUE_APP_API_URL + '/account/bank/deposit/neopay', payload).then((response) => {
				useBonusStore().fetchOffers();
				this.fetchAvailableBonuses('neopay');
				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error.response);
			})
		},
		// Webpayz
		createDepositWebpayz(payload) {
			return global.axios.post(process.env.VUE_APP_API_URL + '/account/bank/deposit/webpayz', payload).then((response) => {
				useBonusStore().fetchOffers();
				this.fetchAvailableBonuses('webpayz');

				// Build and auto-submit form to Webpayz checkout page
				let form = document.createElement('form');
				form.action = response.data.gateway_url;
				form.method = 'post';
				form.style.display = 'none';
				document.body.appendChild(form);

				Object.entries(response.data.form_fields).forEach(([name, value]) => {
					let input = document.createElement('input');
					input.setAttribute('name', name);
					input.setAttribute('value', value);
					form.appendChild(input);
				});

				form.submit();

				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error.response);
			})
		},
		// Paysay
		createDepositPaysay(payload) {
			return global.axios.post(process.env.VUE_APP_API_URL + '/account/bank/deposit/paysay', payload).then((response) => {
				
				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error.response);
			})
		},
		// Aleapay
		createDepositAleapay(payload) {
			return global.axios.post(process.env.VUE_APP_API_URL + '/account/bank/deposit/aleapay', payload).then((response) => {
				
				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error.response);
			})
		},
		// Riverpe
		createDepositRiverpe(payload) {
			return global.axios.post(process.env.VUE_APP_API_URL + '/account/bank/deposit/riverpe', payload).then((response) => {
				// useBonusStore().fetchOffers();
				// this.fetchAvailableBonuses('riverpe');
				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error.response);
			})
		},
		// ModemPay
		createDepositModemPay(payload) {
			return global.axios.post(process.env.VUE_APP_API_URL + '/account/bank/deposit/modempay', payload).then((response) => {
				useBonusStore().fetchOffers();
				this.fetchAvailableBonuses('modem_pay');
				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error.response);
			})
		},
		setPaymentGateways(data) {
			const paymentGatewayStore = usePaymentGatewaysStore();
			this.payment_gateways = data;

			if (this.isCcpaymentEnabled) {
				const ccpayment = data.find(gateway => gateway.slug === 'ccpayment');
				const original_logo_array = ccpayment.logo;
				ccpayment.logo = original_logo_array.find(logo => logo.slug === 'ccpayment') || null;
				const usdt_logo = original_logo_array.find(logo => logo.slug === 'ccpayment_usdt') || null;
				const trx_logo = original_logo_array.find(logo => logo.slug === 'ccpayment_trx') || null;

				const shared_properties = {
					supported_currencies: ccpayment.supported_currencies,
					currencies: ccpayment.currencies,
					deposit_sort: ccpayment.deposit_sort,
				};

				const ccpaymentStore = useCcPaymentStore();
				ccpaymentStore.fetchCurrencies().then((response) => {
					ccpaymentStore.deposit_currencies = response.deposit_coins;

					this.payment_gateways = [...data];

					if (ccpaymentStore.getUsdtCoins('deposit') && ccpaymentStore.getUsdtCoins('deposit').length > 0) {
						this.payment_gateways.push({
							id: 1000,
							slug: 'usdt',
							label: 'USDT',
							logo: usdt_logo,
							...shared_properties
						});
					}

					if (ccpaymentStore.getTrxCoins('deposit') && ccpaymentStore.getTrxCoins('deposit').length > 0) {
						this.payment_gateways.push({
							id: 1001,
							slug: 'trx',
							label: 'TRX',
							logo: trx_logo,
							...shared_properties
						});
					}
				}).catch((error) => {
					console.log(error);
				}).finally(() => {
					paymentGatewayStore.global_deposit_payment_loading = false;
				});
			} else {
				paymentGatewayStore.global_deposit_payment_loading = false;
			}
		}
	},
})